import React from "react";
import { PaintSwatches } from "@one-thd/sui-icons";
import { Link, Typography } from "@one-thd/sui-atomic-components";
import { TPaintOrderLineItem } from "../../types/api";
import { PaintUtils } from "../../utils/paint";

export type TColorSwatch = React.JSX.Element;

const ColorSwatch = ({ paintOrderData }: { paintOrderData: TPaintOrderLineItem }) => {
  // Get the RGB values from the paintOrderData
  const { red, blue, green } = paintOrderData.rgb;
  const { colorType, formulaScaleValue } = paintOrderData;

  // Any color type other than standard EfbColor or Competitive colors will have a Color Tag
  const showColorTag = colorType !== "EfbColor" && colorType !== "CompetitiveColor";

  const color = `rgb(${red}, ${green}, ${blue})`;
  const noColorPreview = color.indexOf("null") > -1;

  // Determine if the color has been adjusted
  const colorWasAdjusted = formulaScaleValue !== 0;

  const Swatch = () => (
    <div
      data-testid="color-swatch"
      className="sui-flex sui-flex-col sui-justify-between sui-items-start sui-aspect-square"
      style={{ backgroundColor: color }}
    >
      <div
        className="sui-w-fit sui-h-fit"
        style={{
          backgroundColor: showColorTag ? "#3E7697" : "none",
          color: "white",
        }}
      >
        {showColorTag && (
          <span
            data-testid="color-tag"
            className="sui-pl-[10px] sui-pr-[10px] sui-text-base sui-font-[700]"
          >
            {PaintUtils.determineColorTag(colorType, colorWasAdjusted)}
          </span>
        )}
      </div>

      {noColorPreview ? (
        <div className="sui-flex sui-flex-col sui-text-center sui-justify-center sui-items-center sui-m-auto sui-w-[120px]">
          <div className="sui-pb-2">
            <PaintSwatches color="medium" />
          </div>
          No Color Preview Available
        </div>
      ) : (
        <img
          data-testid="brand-logo"
          className="sui-h-[50px]"
          width="auto"
          height="auto"
          src={PaintUtils.getPaintBrandLogo(paintOrderData.brandLogo)}
          alt="paint brand"
        />
      )}
    </div>
  );

  return (
    <Link
      href={paintOrderData.clickToActionUrl}
      className={
        paintOrderData.clickToActionUrl
          ? "sui-cursor-pointer"
          : "hover:sui-no-underline sui-cursor-default"
      }
    >
      <Swatch />

      <div className="sui-p-4">
        <Typography variant="body-base" weight="bold">
          {paintOrderData.brandName}
        </Typography>
        <Typography variant="body-base">{paintOrderData.colorName}</Typography>
      </div>
    </Link>
  );
};

export default ColorSwatch;
